<template>
  <span v-if="usuario">
    {{ usuario.user_name }}
  </span>
</template>

<script>
import API from "@/lib/API";
import { mapState } from "vuex";
export default {
  props: ["id_usuario"],
  data() {
    return {
      usuario: undefined,
    };
  },
  computed: {
    ...mapState("comun", ["IdUsuario"]),
  },
  methods: {
    async traer() {
      if (this.id_usuario) {
        if (this.id_usuario == this.IdUsuario) {
          this.usuario = { user_name: "YO" };
        } else {
          this.usuario = await API.Usuarios.traerUno(this.id_usuario);
        }
      }
      else
      {
        this.usuario = undefined;
      }
    },
  },
  mounted() {
    this.traer();
  },
  watch: {
    id_usuario() {
      this.traer();
    },
  },
};
</script>

<style></style>
